import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from './config.service';
import { CardBinDetails, PaymentCollectionResponse, PaymentCollectionResponseByProfileId, PaymentCollectionResponseByTransactionId, SavedCardDetail, VerifyPaymentLinkResponse } from '../model/payment/PaymentCollectionRequest';

@Injectable()
export class PaymentCollectionService {
  private configService: ConfigService;
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient, configService: ConfigService) {
    this.httpClient = httpClient;
    this.configService = configService;
  }

  public async collectPayment(request: string): Promise<PaymentCollectionResponse> {
    const url = this.configService.getPaymentCollectionServiceUrl() + '/payment-collection';
    return await this.httpClient.post<PaymentCollectionResponse>(url, request).toPromise();
  }

  public async getPaymentCollectionByTransactionId(transactionId: string): Promise<PaymentCollectionResponseByTransactionId> {
    const url = this.configService.getPaymentCollectionServiceUrl() + `/payment-details?transactionId=${transactionId}`;
    return await this.httpClient.get<PaymentCollectionResponseByTransactionId>(url).toPromise();
  }
  
  public async getSavedCardDetail(userId: string): Promise<SavedCardDetail> {
    const url = this.configService.getPaymentCollectionServiceUrl() + `/payment-details/card/stored?userId=${userId}`;
    return await this.httpClient.get<SavedCardDetail>(url).toPromise();
  }

  public async getCardBinDetails(partialCardNumber: string): Promise<CardBinDetails> {
    const url = this.configService.getPaymentCollectionServiceUrl() + `/payment-details/card/bin?partialCardNumber=${partialCardNumber}`;
    return await this.httpClient.get<CardBinDetails>(url).toPromise();
  }

  public async getCardBinDetailsForPaymentLink(partialCardNumber: string,uuid: string, token: string): Promise<CardBinDetails> {
    const url = this.configService.getPaymentCollectionServiceUrl() + `/payment-details/card/payment-link-bin?partialCardNumber=${partialCardNumber}&uuid=${uuid}&token=${token}`;
    return await this.httpClient.get<CardBinDetails>(url).toPromise();
  }

  public async getUserPaymentTransactions(profileId: string): Promise<PaymentCollectionResponseByProfileId[]> {
    const url = this.configService.getPaymentCollectionServiceUrl() + `/payment-collection-request?userId=${profileId}`;
    return await this.httpClient.get<PaymentCollectionResponseByProfileId[]>(url).toPromise();
  }

  public async collectBorrowerPayment(request: string): Promise<PaymentCollectionResponse> {
    const url = this.configService.getPaymentCollectionServiceUrl() + '/borrower-payment-collection';
    return await this.httpClient.post<PaymentCollectionResponse>(url, request).toPromise();
  }

  public async verifyPaymentLinkOfIFA(uuid: string, token:string): Promise<VerifyPaymentLinkResponse> {
    const url = this.configService.getPaymentCollectionServiceUrl() + '/payment-collection/verify-payment-link';
    const params = new HttpParams().set('uuid', uuid).set('token',token);
    return await this.httpClient.post<VerifyPaymentLinkResponse>(url, {},{params: params}).toPromise();
  }

  public async collectPaymentIFA(uuid: string,request: string, token: string): Promise<PaymentCollectionResponse> {
    const url = this.configService.getPaymentCollectionServiceUrl() + '/payment-collection/collect-link-payment';
    const params = new HttpParams().set('uuid', uuid).set('token',token);
    return await this.httpClient.post<PaymentCollectionResponse>(url, request,{params: params}).toPromise();
  }

  public async updatePaymentLinkStatus(txnId: string): Promise<any> {
    const url = this.configService.getPaymentCollectionServiceUrl() + '/payment-collection/mark-link-payment-success';
    const params = new HttpParams().set('txnId', txnId);
    return await this.httpClient.patch<any>(url, {},{params: params}).toPromise();
  }

  public async getBorrowerPaymentLinkDetails(referenceId: string): Promise<any> {
    const url = this.configService.getFinzy2CoreLoanServiceUrl() + `/payment/details/${referenceId}`;
    return await this.httpClient.get<any>(url).toPromise();
  }
}
